import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { navItems } from '../../data/mockData';
import { ButtonLink } from '../ui/Button';
import Logo from './Logo';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'border-b border-canvas-300/70 bg-white/85 backdrop-blur-lg'
          : 'bg-transparent'
      }`}
    >
      <nav className="container flex h-20 items-center justify-between gap-6 py-4">
        <Logo />

        <ul className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                    isActive
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-brand-900/70 hover:bg-brand-50 hover:text-brand-800'
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-2 lg:flex">
          <ButtonLink to="/sign-in" variant="ghost" size="md">
            Sign in
          </ButtonLink>
          <ButtonLink to="/apply" variant="primary" size="md">
            Apply
          </ButtonLink>
        </div>

        <button
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-xl border border-canvas-300 bg-white text-brand-800 lg:hidden"
        >
          <FontAwesomeIcon icon={open ? faTimes : faBars} className="h-5 w-5" />
        </button>
      </nav>

      {open && (
        <div className="border-t border-canvas-300 bg-white lg:hidden">
          <ul className="container flex flex-col gap-1 py-4">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === '/'}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `block rounded-xl px-4 py-3 text-sm font-semibold ${
                      isActive
                        ? 'bg-brand-50 text-brand-700'
                        : 'text-brand-900/75 hover:bg-canvas-100'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li className="mt-3 flex flex-col gap-2">
              <ButtonLink to="/sign-in" variant="secondary" size="lg">
                Sign in
              </ButtonLink>
              <ButtonLink to="/apply" variant="primary" size="lg">
                Apply
              </ButtonLink>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
